import type UrlBuilderService from "@app/services/url-builders/url-builder";
import type { SearchInfo } from "@app/types/search-types";

import {
  isReturn,
  removeOutboundLegCardState,
  removeOutboundSearchState
} from "../../../helpers/search";
import { redirect, refresh } from "../../../utils/window";

export const reloadOutboundPage = (
  urlBuilder: UrlBuilderService,
  search: SearchInfo,
  is_async_cart?: boolean
) => {
  const url_redirect = getRedirectUrl(urlBuilder, search, is_async_cart);
  if (url_redirect) {
    return redirect(url_redirect);
  }

  return refresh();
};

export const getRedirectUrl = (
  urlBuilder: UrlBuilderService,
  search: SearchInfo,
  is_async_cart?: boolean
) => {
  if (is_async_cart) {
    return urlBuilder.results({
      ...search,
      leg_card_id: null,
      trip_id: null,
      cart_id: null
    });
  }
  if (isReturn(search)) {
    return urlBuilder.results(removeOutboundSearchState(search));
  }
  return urlBuilder.results(removeOutboundLegCardState(search));
};
